import tw from "twin.macro";

export const Container = tw.div`relative`;
export const ContentWithPadding = tw.div`max-w-screen-xl mx-auto py-10 lg:py-16`;
export const ContentWithVerticalPadding = tw.div`py-10 lg:py-12`;
export const ContentWithVerticalMargin = tw.div`mt-10 lg:mt-12`;
export const Content2Xl= tw.div`max-w-screen-2xl mx-auto`;
